import { Button } from "@mui/material";
import styles from "./CallToLogin.module.scss";
import LoginIcon from "@mui/icons-material/Login";
import { useSelector } from "react-redux";
import { IconPack } from "Explore/Config/Icons";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import { useState } from "react";
import LoginBox from "LandingPage/Components/LoginBox";

const MAP_USER_ROLE = Object.freeze({
  subscribed: "Subscribed Plan",
  normal: "Basic Plan",
});

const CallToLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.data);
  const handleLogin = () => {
    const currentPath = location.pathname + location.search;
    navigate(`/login`, { state: { previousPage: currentPath } });
  };
  const [isOpenLoginDialog, setIsOpenLoginDialog] = useState(false)

  return (
    <>
      <section className={styles["call-to-login"]}>
        {!!user ? (
          <>
            <div className={styles["user-info"]}>
              <div className={styles["user-image"]}>{IconPack.user_profile}</div>
              <div
                className={[styles["content"], styles["user-content"]].join(" ")}
              >
                <h2 className={styles["title"]}>Welcome back!</h2>
                <p className={styles["username"]}>{user.username}</p>
              </div>
            </div>
            <div className={styles["account-type"]}>
              <p className={styles["label"]}>Account type:</p>
              <p className={styles["type"]}>{MAP_USER_ROLE[user.role]}</p>
            </div>
            {/* <Button
              className={styles["button"]}
              variant="contained"
              endIcon={<ArrowForwardIcon />}
            >
              Manage account
            </Button> */}
          </>
        ) : (
          <>
            <div className={styles["content"]}>
              <h2 className={styles["title"]}>Join us for free!</h2>
              <p className={styles["description"]}>
                Log in now to unlock deeper insights
              </p>
            </div>
            <Button
              className={styles["button"]}
              variant="contained"
              endIcon={<LoginIcon />}
              onClick={() => setIsOpenLoginDialog(true)}
            >
              Log in
            </Button>
          </>
        )}
        
      </section>
      <Modal open={isOpenLoginDialog} onClose={() => setIsOpenLoginDialog(false)}>
        <div className={styles["login-modal"]}>
          <LoginBox />
        </div>
      </Modal>
    </>
  );
};

export default CallToLogin;
